import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import { AuthContext } from './AuthContext';

export const SocketContext = createContext();

export const SocketContextProvider = ({ children }) => {
  const { currentUser } = useContext(AuthContext);
  const socketRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (currentUser && !socketRef.current) {
      const SERVER_URL = 'https://ng-api-p21r.onrender.com';

      const socketInstance = io(SERVER_URL, {
        withCredentials: true,
        transports: ['websocket', 'polling'],
        reconnection: true,
        reconnectionAttempts: 10,
        reconnectionDelay: 500,
      });

      socketInstance.on('connect', () => {
        setIsConnected(true);
        socketInstance.emit('newUser', currentUser?.user?.id);
      });

      socketInstance.on('connect_error', (err) => {
        console.error('Socket connection error:', err.message);
      });

      socketInstance.on('disconnect', (reason) => {
        console.warn('Socket disconnected:', reason);
        setIsConnected(false);
      });

      socketRef.current = socketInstance;
    }

    return () => {
      if (socketRef.current) {
        socketRef.current.emit('removeUser', currentUser?.user?.id);
        socketRef.current.disconnect();
        socketRef.current = null;
        setIsConnected(false);
      }
    };
  }, [currentUser]);

  return (
    <SocketContext.Provider value={{ socket: socketRef.current, isConnected }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
